<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <!-- Data Peserta -->
  <CCardBody>
    <CRow>
      <div class="col-sm-12 col-xl-6">
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Periode</label>
          <multiselect
            class="multi-select"
            label="label"
            placeholder="Pilih Periode"
            :show-labels="false"
            required
            v-model="periode"
            @select="changePeriode"
            :options="dataTahun"
          ></multiselect>
        </div>
      </div>
      <div class="col-sm-12 col-xl-6">
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Sertifikasi</label>
          <multiselect
            class="multi-select"
            label="nama_rpl"
            placeholder="Pilih Sertifikasi"
            :show-labels="false"
            required
            v-model="nama_rpl"
            @select="changeSertifikasi"
            :options="dataSertifikasi"
          ></multiselect>
        </div>
      </div>

      <div class="col-sm-12 col-xl-12">
        <!-- <div style="float: left">
          <button class="btn btn-info" @click="download">
            Download Data Pembayaran
          </button>
        </div> -->
        <div style="float: right">
          <button class="btn btn-info mr-2" @click="resetFilter">
            Reset Filter
          </button>
          <button class="btn btn-success" @click="changePelatihan">
            Terapkan Filter
          </button>
        </div>
      </div>
    </CRow>
  </CCardBody>
  <!-- End Data Peserta -->
</template>

<script>
import PeriodeService from "@/services/datamaster/periode-rpl.service";
import PaymentService from "@/services/finance/payment.service";
import MasterSertifikasiRplService from "@/services/rpl/master-rpl.service";
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
import { KategoriAnggota } from "@/mixins/master/KategoriAnggota";
import { exportUtils } from '@/mixins/exportUtils';

export default {
  mixins: [AlertUtils, Pagination, KategoriAnggota, exportUtils],  
  data() {
    return {
      formFilter: {
        periode: "",
        value: "",
        id_sertifikasi_rpl: "",
      },
      tipe: "pembayaran_sertifikasi",
      nama_rpl: "",
      periode: "",
      kategori_anggota: "",
      dataSertifikasi: [],
      items: [],
      dataPelatihan: [],
      dataTahun: [],
      details: [],
      status: false,
      myModal: false,
      modalDetail: false,
      modalDetailPeserta: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
    };
  },

  mounted() {
    this.getPeriode();
  },

  methods: {
    changeSertifikasi(value) {
      this.formFilter.id_sertifikasi_rpl = value.id_sertifikasi_rpl;      
    },

    filterData() {
      this.$parent.filterData(this.formFilter);
    },

    resetFilter() {
      this.periode = "";
      this.nama_rpl = "";
      $("#filterStatusPembayaran").val("");
    },    

    getPeriode() {
      PeriodeService.getPeriodeSelect()
        .then((response) => {
          this.dataTahun = response.data.data;
          var periode = this.dataTahun.find((el) => el.status === "1");
          
          
          this.periode = {
            label: periode.label,
            value: periode.value
            };
          this.formFilter.periode = periode.value;
          this.getSertifikasi()
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getSertifikasi() {
      MasterSertifikasiRplService.getDataSertifikasiRpl(0, 100000, "default")
        .then((response) => {
          this.dataSertifikasi = response.data.data.content;
          this.nama_rpl = {
            nama_rpl : this.dataSertifikasi[0].nama_rpl
          }         
          this.formFilter.id_sertifikasi_rpl = this.dataSertifikasi[0].id_sertifikasi_rpl
          var value = {
            id : this.formFilter.id_sertifikasi_rpl,
            periode : this.formFilter.periode,
          }
          this.$parent.changePelatihan(value);
        })
        .catch((error) => {
          onsole.log(error);
        });
    },

    changePelatihan() {
      var value = {
        id : this.formFilter.id_sertifikasi_rpl,
        periode : this.formFilter.periode,
      }
      this.$parent.changePelatihan(value);
    },

    changePeriode(value) {
      this.formFilter.periode = value.value
    },

    download(value) {
      var value = {
        id : this.formFilter.id_sertifikasi_rpl,
        periode : this.formFilter.periode,
      }
      this.$parent.download(value);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
